/* eslint-disable camelcase */
export default class PurchaseOrder {
  partner_id = null;
  sales_rep_id = null;
  shipper_id = null;
  sales_order_reference = null;
  is_so_ref = false;
  case_type = null;
  reason = null;
  po_type = null;
  payment_term_id = null;
  purchase_order_items = [];
  order_no = '';
  partner_store = {
    is_tax_exemption: '',
    lookup_province: {
      lookup_tax_code: ''
    }
  };
  partner = {
    name: ''
  };
  lookup_purchase_order_status = {
    status: ''
  };
  lookup_purchase_order_voucher_status = {
    status: ''
  };
  delivery_slips = [];
  created_user = {
    username: ''
  };
  updated_user = {
    username: ''
  };
  memo = '';
  is_editable = false;
}



// WEBPACK FOOTER //
// ./resources/assets/js/_shared/models/PurchaseOrder.js